import { 
    useEffect, 
    useState 
} from "react";

import "./AutoTable.css";

// export default function AutoTable(props) {
export default function AutoTable({th, onSearch, onSort, sortOrder, noFilter, children, ...rest}) {
    // const [th, setTh] = useState([]);
     const [headerRows, setHeaderRows] = useState([]);
    const [filterRow, setFilterRow] = useState([]);

    useEffect(() => {
        // if (props.th === undefined) return;
        if(!th) return;

        const resTh = [];
        const resFilterRow = [];

        // props.th.forEach((row) => {
        th.forEach((row) => {
            const {
                id,
                name,
                width,
                span,
                type
            } = row;

            const rTh = (
                <th 
                    className="regular-th"
                    key={ id } 
                    scope="col"
                    colSpan={ span }
                    style={{ width: width, cursor: name === "Hire Date" ? 'pointer' :  'default' }}
                    // onClick={() => { if (props.onSort !== undefined) props.onSort(id) }}
                    onClick={() => {if(onSort) onSort(id)}}
                >
                    
                { name && (name === "Hire Date" ? (<span style={{ marginLeft: "6px" }}>{sortOrder === 'asc' ? '▲' : '▼'} {name}</span>) : name)}
                </th>
            );

            const rFilterRow = (
                <th
                    className="filter-th"
                    key={ `filter_${id}` }
                    colSpan={ span }
                    style={{ width: width }}
                >
                {
                    type !== undefined && (
                        <input 
                            className="filter-input"
                            type={ type } 
                            onChange={(e) => { 
                                // if(props.onSearch !== undefined) { 
                                //     props.onSearch(id, type === "checkbox" ? e.target.checked : e.target.value);
                                // }
                                if(onSearch) {
                                    onSearch(id, type === "checkbox" ? e.target.checked : e.target.value);
                                }
                            }} 
                        />
                    )
                }
                </th>
            );

            resTh.push(rTh);
            resFilterRow.push(rFilterRow);
        });

        setHeaderRows(resTh);
        setFilterRow(resFilterRow);
    },[ th, onSort, sortOrder, onSearch]);

    return (
        // <div className="autotable-container" { ...props }>
        <div className="autotable-container" { ...rest }>
            <table className="autotable-header-table">
                <thead>
                    <tr className="tr-header">
                        {/* {th} */}
                        {headerRows}
                    </tr>
                    {
                        // !props.noFilter && (
                        !noFilter && (
                            <tr className="tr-filter">
                                {filterRow}
                            </tr>
                        )
                    }
                </thead>
                {/* <tbody>{ props.children }</tbody> */}
                <tbody>{ children }</tbody>
            </table>
        </div>
    );
}